<template>
    <div :class="cn(boxVariants({ variant }))">
        <div :class="cn(iconColorVariants({ variant }))"></div>

        <div>
            <p class="font-medium">
                <slot name="title" />
            </p>

            <p class="mt-1 text-sm">
                <slot name="content" />
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/cn";

defineProps<Props>();

const boxVariants = cva(
    "rounded-md gap-2 flex border border-[#E5E7EB] bg-white p-4",
    {
        variants: {
            variant: {
                default: "bg-blue-50 text-blue-800",
                success: "bg-green-50 text-green-800",
                alert: "bg-red-50 text-red-800",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

const iconColorVariants = cva("mt-2 h-2 w-2 rounded-full bg-current", {
    variants: {
        variant: {
            default: "bg-blue-500",
            success: "bg-green-500",
            alert: "bg-red-500",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

type BoxVariantProps = VariantProps<typeof boxVariants>;

interface Props {
    variant?: BoxVariantProps["variant"];
}
</script>
